export const PROFILE_LISTING_SORT = [
  { value: 'newest', label: 'Newest' },
  { value: 'oldest', label: 'Oldest' },
  { value: 'lowest price', label: 'Lowest price' },
  { value: 'highest price', label: 'Highest price' },
];

export const SEARCH_AND_SORT_SORTBY = {
  CASE_NEWEST: 'newest',
  CASE_OLDEST: 'oldest',
  CASE_LOWEST: 'lowest price',
  CASE_HIGHEST: 'highest price',
  VALUE_NEWEST: 'createdAt',
  VALUE_OLDEST: '-createdAt',
  VALUE_LOWEST: '-price',
  VALUE_HIGHEST: 'price',
};

export const WISHLIST_PAGE = {
  LISTING_PAGE: 'ListingPage',
};


export const paypalIcon =
  'https://icons.veryicon.com/png/o/business/online-payment/payment-platform-paypal.png';
export const stripeIcon = 'https://cdn-icons-png.flaticon.com/512/5968/5968382.png';
export const tickIcon =
  'https://thumbs.dreamstime.com/b/tick-icon-vector-symbol-checkmark-isolated-white-background-tick-icon-vector-symbol-checkmark-vector-illustration-isolated-139167756.jpg';
export const PAYPAL_MERCHANT_PAGE = '/account/paypal-merchant';
export const EXTERNAL_MERCHANT_LINK = 'https://www.paypal.com/us/webapps/mpp/account-selection';
export const PAYPAL_CLIENT_ID = process.env.REACT_APP_PAYPAL_CLIENT_ID;
